import { IOffer } from '../../../types/offer';
import { numberToPrettyString } from '@cian/utils';

export function getTotalArea(offer: IOffer): string | undefined {
  if (offer.totalArea) {
    return numberToPrettyString(Number(offer.totalArea));
  }

  return undefined;
}
